import React from "react";
import { SavedSearchSettingsChannelItem } from "./SavedSearchSettingsChannelItem";
import { ItemSeparator, LastItemSeparator } from "../styles";
import { Category, Channel, SupportedChannels } from "../../model/model";
import { useAppTranslation } from "../../locales/translate";

type Props = {
  toggleChannel: (channel: Channel) => void;
  isChannelSelected: (channel: Channel) => boolean;
  category: Category;
};

const settings = [
  {
    channel: Channel.WEB,
    name: "SETTINGS_CHANNEL_NAME_WEB",
    description: "SETTING_CHANNEL_DESCRIPTION_WEB",
  },
  {
    channel: Channel.PUSH,
    name: "SETTINGS_CHANNEL_NAME_PUSH",
    description: "SETTING_CHANNEL_DESCRIPTION_PUSH",
  },
  {
    channel: Channel.EMAIL,
    name: "SETTINGS_CHANNEL_NAME_EMAIL",
    description: "SETTING_CHANNEL_DESCRIPTION_EMAIL",
  },
] as const;

const getSupportedChannelsSettings = (category: Category) =>
  settings.filter(({ channel }) =>
    SupportedChannels[category].includes(channel)
  );

export const SavedSearchSettingsChannels = ({
  toggleChannel,
  isChannelSelected,
  category,
}: Props) => {
  const { t } = useAppTranslation();
  const channels = getSupportedChannelsSettings(category);
  return (
    <>
      {channels.map((setting, i) => (
        <div key={setting.channel}>
          <SavedSearchSettingsChannelItem
            name={t(setting.name)}
            description={t(setting.description)}
            value={isChannelSelected(setting.channel)}
            handleToggleNotifications={() => toggleChannel(setting.channel)}
          />
          {i + 1 === channels.length ? (
            <LastItemSeparator />
          ) : (
            <ItemSeparator />
          )}
        </div>
      ))}
    </>
  );
};
